import { FormItem, Input } from '@vkontakte/vkui';
import React from 'react';
import PropTypes from 'prop-types';
import { prepareString } from '../../../helpers/helpers';

export const NameInputComponent = ({error, setError, name, setName, label, errorTextMinLength, disabled}) => {
  return (<FormItem
    top={label}
    status={error.length > 0 ? 'error' : ''}
    bottom={error}
  >
    <Input
      minLength={2}
      maxLength={255}
      value={name}
      onChange={(event) => {
        if ([...event.target.value].length <= 255) {
          setName(event.target.value);
        }
      }}
      disabled={disabled}
      onBlur={() => {
        setName(prepareString(name));
        setError([...prepareString(name)].length < 2 ? errorTextMinLength : '');
      }
    }/>
  </FormItem>);
}

NameInputComponent.propTypes = {
  error: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  errorTextMinLength: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};
